import { useEffect } from "react";

import "../assets/scss/components/_product-sizes.scss";
import { useProductStore } from "../stores/ProductStore";
import type { ProductSizesProps } from "../types/components/ProductSizesProps";

export const ProductSizes = ({ propSizes = [], currentImageShowing = false }: ProductSizesProps) => {
	const { info, selectedSize, sizes, GetSizes, SetSize } = useProductStore((state) => state);

	const productSizes = propSizes.length > 0 ? propSizes : sizes;

	useEffect(() => {
		GetSizes();
	}, [GetSizes]);

	return (
		<section className="size-section-container">
			<strong className="section-title">Choose your {info.product_type === "Subscription" ? "frequency:" : "size:"}</strong>
			<div className="size-section row justify-content-space-between">
				{/* <span className="stem-label">{info.product_type === "Subscription" ? "Frequency" : "Stem Count"}</span> */}
				{productSizes && productSizes.length > 0 ? (
					<>
						{productSizes.map((size, index) => {
							return (
								<div
									key={index}
									className={`row justify-content-space-between col-fluid size-choice ${selectedSize === size.size ? "active" : ""}`}
									onClick={() => SetSize(size.size)}
								>
									<div className="col-fluid row align-items-start">
										{size.size_text} {parseFloat(size.price) !== 0 && `(+£${parseInt(size.price)})`}
										{size.size_text === "Large" && <span className="popular-choice">Popular</span>}
										{size.size_text === "Medium" && <span className={`size-shown size-shown-desk medium-shown medium-shown-desk ${currentImageShowing === 0 ? "active" : ""}`}>Size shown in the current picture</span>}
										{size.size_text === "Large" && <span className={`size-shown size-shown-desk large-shown large-shown-desk ${currentImageShowing !== 0 ? "active" : ""}`}>Size shown in the current picture</span>}
										{size.size_text === "Over 6ft" && <span className={`popular-choice`}>Most Popular!</span>}
									</div>
								</div>
							);
						})}
					</>
				) : (
					<div className={`row justify-content-space-between align-items-center size-choice active`}>
						<div className="col-fit">
							<div className="stem-count active">14</div>
						</div>
						<div className="col-fluid">One Size</div>
					</div>
				)}
				<span className="size-shown size-shown-mob col-12">{currentImageShowing === 0 ? "Medium" : "Large"} bouquet is shown in current picture</span>
			</div>
		</section>
	);
};
